import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  InputLabel,
  FormControl,
  Select,
  Popper,
  Grow,
  Paper,
  Box,
} from "@mui/material";
import { useTheme, styled } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  languages,
  languageIcons,
  languageMapping,
} from "../../config/localization"; // [{code,label,icon}]
import { useData } from "../../contexts/DataContext/DataContextt";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const LanguageSelector = () => {
  const { updateLanguage, language } = useData();
  const [anchorEl, setAnchorEl] = useState(null);
  const anchorRef = React.useRef(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl((prev) => (prev ? null : event.currentTarget));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (langCode) => {
    updateLanguage(langCode);
    handleClose();
  };

  const selectedCode = languageMapping.find((l) => l.source === language)?.code;
  const label = "Choose language";
  const StyledPopper = styled(Popper)(({ theme }) => ({
    border: "1px solid #e1e4e8",
    boxShadow: `0 8px 24px ${"rgba(149, 157, 165, 0.2)"}`,
    color: "#24292e",
    backgroundColor: "#fff",
    borderRadius: 6,
    width: "270px",
    zIndex: theme.zIndex.modal,
    fontSize: 13,
    ...theme.applyStyles("dark", {
      border: "1px solid #30363d",
      boxShadow: "0 8px 24px rgb(1, 4, 9)",
      color: "#c9d1d9",
      backgroundColor: "#1c2128",
    }),
  }));

  return (
    <div
      style={{
        width: "95%",
        paddingTop: "5px",
        paddingBottom: "5px",
        display: "flex",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Button
        disableRipple
        aria-describedby={"test"}
        onClick={handleClick}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%", // or 100% if you want full width
        }}
      >
        <span>Choose Language {languageIcons[selectedCode]}</span>
        <SettingsIcon />
      </Button>
      <StyledPopper
        id={"popperStyled"}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-end"
      >
        <ClickAwayListener onClickAway={handleClose}>
          <div>
            <Box
              sx={(t) => ({
                borderBottom: "1px solid #30363d",
                padding: "8px 10px",
                fontWeight: 600,
                ...t.applyStyles("light", {
                  borderBottom: "1px solid #eaecef",
                }),
              })}
            >
              {languageMapping.map((option, index) => {
                return (
                  <MenuItem
                    key={`${option}-${index}`}
                    onClick={() => handleSelect(option.code)}
                  >
                    {languageIcons[option.code] && (
                      <span style={{ marginRight: 8 }}>
                        {languageIcons[option.code]}
                      </span>
                    )}
                    {option.code}
                  </MenuItem>
                );
              })}
            </Box>
          </div>
        </ClickAwayListener>
      </StyledPopper>
    </div>
  );
};

export default LanguageSelector;
